import React, { Component } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Button from 'react-bootstrap/Button';
import ProgressBar from 'react-bootstrap/ProgressBar';

import './App.css';


import ReactGA from 'react-ga';

ReactGA.initialize('UA-151325801-1');
ReactGA.pageview('/homepage');


class App extends Component {
  render(){
    return (
      <div className="App container">
        <Heading/>
        <Bio/>
        <Edu/>
        <Skills/>
        <Languages/>
        <Projects/>
        <Exp/>
      </div>
    );
  }
}


class Heading extends Component{
  render(){
    return(
      <h1 className = "pt-3"> Elena Rastorgueva </h1>
      )
  }
}

class Bio extends Component{
  render(){
    return(
      <div className = "row py-3 justify-content-around" >
        <div className = "col-lg-3 col-md-3 col-6">
          <img alt="portrait" src="portrait.jpg" 
          className= "rounded-circle img-fluid mx-auto" 
          />
        </div>

        <div className="col-lg-8 col-md-8 col-12 my-auto py-3 mx-auto" >
          <p className=" my-auto mx-auto pt-2">Deep Learning Applied Scientist at NVIDIA.</p>
          <p className="my-auto mx-auto">Cambridge MEng grad ('19). Interested in solving problems, often with Machine Learning.</p>
          <div className="row mx-auto">
            <div className="col-lg-6 col-9 justify-content-around mx-auto my-3">
              <a href="https://github.com/elenaras"> <i className="fa fa-github mx-3"/></a>
              <a href = "https://www.linkedin.com/in/elena-rastorgueva/"> <i className="fa fa-linkedin mx-3"/></a>
              <a href="https://twitter.com/ElenaSRas"> <i className="fa fa-twitter mx-3"/></a>                     
            </div>
          </div>
        </div>
      </div>
      )
  }
}

// Education section


class PopoverComponent extends Component {
  render() {
    return(
      <Popover {...this.props} id={this.props.module}>
        <Popover.Title as="h3">Topics included:</Popover.Title>
        <Popover.Content>
          {this.props.topics}
        </Popover.Content>
      </Popover>
      )
  }
}


class ModuleButton extends Component {
  render(){
    return(
      <span>
        <OverlayTrigger trigger="click" placement="bottom" 
        overlay={<PopoverComponent topics = {this.props.topics} id={this.props.module} />}>
          <Button className = "mx-1 my-2" variant="outline-info"><strong>{this.props.module}</strong></Button>
        </OverlayTrigger>
      </span>
      )
  }
}

class ModuleCollection extends Component {
  render(){
    return(
        <div className="px-2">
          <div className="row py-1 justify-content-between">
            <h5 className="mx-auto"> Modules taken: </h5>
          </div>
          <div className = "row justify-content-center">
            <ModuleButton module="Probabilistic Machine Learning" 
                topics="Gaussian Processes, EM Algorithm, Gibbs Sampling, LDA"/>
            <ModuleButton module="Deep Learning" 
                topics="NNs, CNNs, RNNs, optimisation approaches"/>
            <ModuleButton module="Computer Vision" topics="Edge, corner, blob detection, projection, stereo vision, CNNs"/>
            <ModuleButton module="Statistical Signal Processing" topics="Time series models (AR, MA, ARMA), Wiener filters, Matched filters, Markov Chains "/>
            <ModuleButton module="Statistical inference" topics="Regression, Classification, Dimensionality Reduction, Clustering, Monte Carlo sampling"/>
            <ModuleButton module="Information Theory & Coding" topics="Statistical entropy, Huffman/Arithmetic coding, Channel Coding Theorem  "/>
            <ModuleButton module="Software Engineering" topics="OOP, UML, Design Patterns, Software Development Methodologies"/>
            <ModuleButton module="Computer Systems" topics="Instruction set architectures, ALU design, memory hierarchy, input/output, C++ multithreading"/>
            <ModuleButton module="Computational Neuroscience" topics="Reinforcement Learning, Cortical Circuits, Representational Learning, Hopfield Networks"/>
          </div>
        </div>
      )
  }
}


class Edu extends Component {
  render(){
    return(
      <div className="py-5 mx-1">
        <div className = "row py-2 justify-content-between">
          <div className="col-lg-2">
            <h3 className=""> Education </h3>
          </div>
          <div className = "col-lg-10 card border-warning rounded">
            <div className = "card-body row justify-content-around">
              <img src="cam_crest.png" className="col-lg-2 col-3 img-fluid my-auto mx-auto py-2" alt = "cambridge crest"/>
              <div className="col-lg-10 col-10 ">
                <div className = "card-title float-center">
                 <h5 >University of Cambridge (2015-19)</h5>
                </div>
                <div className = "card-text float-left">
                  <p className="float-left"> MEng BA Engineering, Upper Second Class (specialising in <a href="http://www.eng.cam.ac.uk/research/academic-divisions/information-engineering"> Information Engineering)</a>.</p>
                  <p className="float-left"> Thesis (First Class grade): <a href="thesis.pdf"> Neural Hidden Markov Models for Word Alignment</a>.</p>
                </div>
              </div>
              <ModuleCollection/>
            </div>
          </div>
        </div>

      </div>
      )
  }
}

/// Skills section

class SkillLineHorizontal extends Component {
  render(){
    return(
      <div>
        <ul className="my-2 list-group list-group-horizontal-md">
          <li className = "list-group-item list-group-item-info">
            <strong>{this.props.heading}</strong>
          </li>
          {this.props.skillArray.map((item, index) => (
            <li className="list-group-item flex-fill"> {item} </li>
            ))}
        </ul> 
      </div>
      )
  }
}

class SkillLineVertical extends Component {
  render(){
    return(
      <div>
        <ul className="my-3 list-group">
          <li className = "list-group-item list-group-item-info text-left">
            <strong>{this.props.heading}</strong>
          </li>
          {this.props.skillArray.map((item, index) => (
            <li className="list-group-item flex-fill text-left"> {item} </li>
            ))}
        </ul> 
      </div>
      )
  }
}



class Skills extends Component {
  render(){
    return(
      <div className = "row py-4 justify-content-between">
        <h3 className="col-lg-1 mr-5"> Technical Skills </h3>

        <div className = "col-lg-10 col-8 list-group mx-auto d-none d-lg-block">        
          <SkillLineHorizontal heading = "Python"
            skillArray = {["pandas","scikit-learn", "TensorFlow", "PyTorch","OpenCV", "Selenium"]}
          />
          <SkillLineHorizontal heading = "Web" 
            skillArray = {["HTML/CSS", "React JS (used to build this website)", "React Native", "TensorFlow js", "Flask"]}
          />
          <SkillLineHorizontal heading = "Remote instances & deployment" 
            skillArray = {["AWS", "GCP", "Heroku"]}
          />
          <SkillLineHorizontal heading = "Other" 
            skillArray = {["C++", "SQL", "Git", "MATLAB", "Simulink"]}
          />
        </div>
        <div className = "col-lg-10 col-11 list-group mx-auto d-block d-lg-none">        
          <SkillLineVertical heading = "Python"
            skillArray = {["pandas, scikit-learn, TensorFlow, PyTorch , OpenCV, Selenium"]}
          />
          <SkillLineVertical heading = "Web" 
            skillArray = {["HTML/CSS, React JS (used to build this website), React Native, TensorFlow js, Flask"]}
          />
          <SkillLineVertical heading = "Remote instances & deployment" 
            skillArray = {["AWS, GCP, Heroku"]}
          />
          <SkillLineVertical heading = "Other" 
            skillArray = {["C++, SQL, Git, MATLAB, Simulink"]}
          />
        </div>

      </div>
    )
  }
}

// Languages section

class LangLine extends Component {
  render() {
    return(
      <div className = "col-lg-2 col-6">
        <div className = "row mx-auto">
          <strong>{this.props.language}</strong>
        </div>
        <div className="row">
          <div className = "col-12">
            <ProgressBar now={this.props.percent} variant = "info" />
          </div>
        </div>
      </div>
      )
  }
}

class Languages extends Component {
  render(){
    return(
      <div>
        <div className = "row py-5 justify-content-between">
          <h3 className="col-lg-1 mr-5"> Languages </h3>

          <div className = "col-lg-10 mx-auto"> 
            <div className="row justify-content-between">
              <LangLine language="English" percent = {100} />
              <LangLine language="Russian" percent = {95} />              
              <LangLine language="Mandarin" percent = {50} />              
              <LangLine language="French" percent = {35} />              
              <LangLine language="Spanish" percent = {30} />                             
            </div>
          </div>
        </div>
      </div>
      )
  }
}


// Projects section

class Projects extends Component {
  render(){
    return(
      <div className = "row py-4 justify-content-around mx-1">
        <h3 className="col-lg-2 col-10"> Projects </h3>

        <div className = "col-lg-3 col-md-4 col-10 card border-warning">
          <img src="wang_et_al_screenshot_2.PNG" class="card-img-top px-1 py-2" alt="..."/>
          <div class="card-body">
            <h5 class="card-title">Accepted NLP paper @ EMNLP 2019 WNUT workshop</h5>
            <p class="card-text text-justify">Worked with fellow Cambridge students in our spare time to write a paper about a new clustering technique which we used to cluster users with similar experiences on Reddit using the BERT next sentence prediction model.</p>
          </div>
          <div class="card-body">
            <a href="wang_et_al.pdf" class="card-link">Paper</a>
          </div> 
        </div>

        <div className = "col-lg-3 col-md-4 col-10 card border-warning">
          <img src="tone_trainer.png" class="card-img-top px-1 py-2" alt="..."/>
          <div class="card-body">
            <h5 class="card-title">Mandarin Tone Trainer</h5>
            <p class="card-text text-justify">Reached #1 on Hacker News in December 2019. ML project addressing a problem I've always had when learning Mandarin: knowing if I'm saying words in the correct tone.
              Developed an MVP with TensorFlowJS and ReactJS.</p>
          </div>
          <div class="card-body">
            <a href="https://mandarintonetrainer.com" class="card-link">Website</a>
            <a href="https://www.facebook.com/MandarinToneTrainer" class="card-link">Social media</a>
          </div>
        </div>

        <div className = "col-lg-3 col-md-4 col-10 card border-warning">
          <img src="learnah_cue_prize.jpg" class="card-img-top px-1 py-2" alt="..."/>
          <div class="card-body">
            <h5 class="card-title">LearnAh! EdTech products</h5>
            <p class="card-text text-justify">Worked with 3 fellow Cambridge students to develop EdTech products: 
            (1) an "AI tutor" website which can suggest relevant learning resources for any homework question,
            (2) a website which suggests engaging science videos based on students’ interests.
            </p>
          </div>
          <div class="card-body">
            <a href="http://learnah.org" class="card-link">Website 1</a>
            <a href="http://learnah.uk" class="card-link">Website 2</a>
          </div>
        </div>        
      </div>
    )
  }
}

// Experience Section
class ExpNvidia extends Component {
	render() {
		return(
	      <div className = "py-3">
	        <div className = "border border-info rounded">      
	          <div className = "row mx-3 my-3">
	            <div className = "col my-auto">
	              <h5 className="text-left"> Deep Learning Applied Scientist @ NVIDIA (since March 2021)</h5>
	              <p className="text-justify"> Working on the NVIDIA Conversational AI team.</p> 
	            </div>
	          </div>
	        </div>
	      </div>   
		)
	}
}

class ExpAmazon extends Component {
	render() {
		return(
	      <div className = "py-3">
	        <div className = "border border-info rounded">      
	          <div className = "row mx-3 my-3">
	            <div className = "col my-auto">
	              <h5 className="text-left"> Applied Science Intern @ Amazon (July 2020 - February 2021)</h5>
	              <p className="text-justify"> Worked within the Alexa Text To Speech division.</p> 
	            </div>
	          </div>
	        </div>
	      </div>   
		)
	}
}

class ExpMila extends Component {
  render() {
    return(
      <div className = "py-3">
        <div className = "border border-info rounded">      
          <div className = "row mx-3 my-3">
            <div className = "col-lg-3 col-md-3 col-5 mx-auto my-auto pb-2 d-none d-sm-block">
              <img className = "img-fluid" src="speechbrain_logo.png" alt="DSG"/>
            </div>
            <div className = "col-lg-9 col-md-9 my-auto">
              <h5 className="text-left">Intern @ Mila (SpeechBrain project) (Feb - June 2020)</h5>
              <p className="text-justify"> Worked on HMM-DNN speech recognition functionality for <a href="https://speechbrain.github.io">SpeechBrain</a>, a new toolkit for state-of-the-art speech technologies.
	              Applied the word alignment techniques I developed during my Masters project to speech.</p> 
            </div>
          </div>
        </div>
      </div>          
      )
  }
}

class ExpTHU extends Component {
  render() {
    return(
      <div className = "py-3">
        <div className = "border border-info rounded">
          <div className = "row mx-3 my-4 justify-content-around">
            <div className = "col-sm-4 d-none d-sm-block">
              <img className = "img-fluid " src="thu_nlp.jpg" alt=""/>
            </div>
            <div className = "col-sm-4 d-none d-sm-block">
              <img className = "img-fluid" src="hololens.jpg" alt=""/>
            </div>
            <div className = "col-sm-4 col-12">
              <img className = "img-fluid" src="temple_heaven_group.jpg" alt=""/>
            </div>
          </div>
          <div className = "row mx-3 my-3">
            <h5> Deep Learning Summer School @ Tsinghua University, Beijing (July 2019)</h5>
            <p className="text-justify">Undertook 2-week programme, during which I attended lectures from Tsinghua academics in <a href="http://ss.cs.tsinghua.edu.cn/content.html"> topics </a>such as NLP, Knowledge Graphs, Robotics, Deep Generative Models, RL.
            Commended as top-achieving student with best performance on labwork.
            Visited local companies: Lenovo and Microsoft Asia.</p>
          </div>
        </div>
      </div>
      )
  }
}


class ExpCUERRoles extends Component{
  render(){
    return(
      <div>
        <div className="row py-1">
          <div className="col-lg-2">
            <strong>Head of Race Strategy</strong> <p><em>(Oct '17-'18)</em></p>
          </div>
          <div className="col-lg-10 pb-2 text-justify">
            Led team in develop vehicle energy consumption model using industry-standard software.
            Implemented new process to help verify validity of model against previous race data. 
          </div>
        </div>

        <div className="row py-1">
          <div className="col-lg-2">
            <strong>Business Manager</strong> <p><em>(June '16-Oct '17)</em></p>
          </div>
          <div className="col-lg-10 pb-2 text-justify">
          Managed team raising money in sponsorship towards the 2017 World Solar Challenge, a 3,000km race through Australia.
          Negotiated agreements with new and existing sponsors.
          Gave pitches & presentations at external events.
          </div>
        </div>
        <div className="row py-1">
          <div className="col-lg-2">
            <strong>Solar Car Driver</strong> <p><em>(Sep '16)</em></p>
          </div>
          <div className="col-lg-10 pb-2 text-justify">
            Completed 4 hours of racing in the iLumen European Solar Challenge 2016, a 24-hour race around the Zolder race track.
            Organised car testing and driver training leading up to the race.
          </div>
        </div>
        <div className="row py-1">
          <div className="col-lg-2">
            <strong>Systems integrator</strong> <p><em>(Jun-Sep '16)</em></p>
          </div>
          <div className="col-lg-10 pb-2 text-justify">
            Completed project as part of the Cambridge University Eco Racing Summer Design Team for designing the 2017 solar race car.
            Worked with rest of team (12 students) to manage interfaces between car’s subsystems.
            Improved knowledge of EV technology incl. energy management, motor control, CAN protocol.
          </div>
        </div>
      </div>
      )
  }
}


class ExpCUER extends Component{
  render(){
    return(
      <div className = "py-3">
        <div className = "border border-info rounded">
          <div className = "row mx-3 my-4 justify-content-around">         
            <div className = "col-sm-4 col-12 my-auto">
              <img className = "img-fluid" src="elena_evo.jpg" alt=""/>
            </div>
            <div className = "col-sm-4 my-auto d-none d-sm-block">
              <img className = "img-fluid" src="elena_evo_2.PNG" alt=""/>
            </div>
            <div className = "col-sm-4 my-auto d-none d-sm-block">
              <div class="embed-responsive embed-responsive-1by1">
                <iframe class="embed-responsive-item" 
                  src="https://www.instagram.com/p/BJin5oUBXvX/embed/" 
                  title="talking about CUER on instagram"
                  allowfullscreen></iframe>
              </div>
            </div> 
          </div>
          <div className = "row mx-3 my-3">
            <h5 className = "pb-1">Numerous roles @ Cambridge University Eco Racing (Oct 2015 - 2018)</h5>
            <ExpCUERRoles/>
          </div>
        </div>
      </div>
      )
  }
}

class ExpHuawei extends Component {
  render(){
    return(
      <div className = "py-3">
        <div className = "border border-info rounded">
          <div className = "row mx-3 my-4 justify-content-around">
            <div className = "col-sm-8 col-12">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/B_2BHDF2zJ8" title="Huawei programme video" allowfullscreen></iframe>
              </div>
            </div>
          </div>
          <div className = "row mx-3 my-3">
            <h5> Huawei Seeds for the Future Programme @ Beijing & Shenzhen (July/Aug 2018)</h5>
            <p className="text-justify">Undertook 4-week programme, during which we visited Huawei & other companies (e.g. Hyundai, BYD, 36Kr, Ping An).</p>
            <p className="text-justify">Completed 1-week telecommunications course & 1-week intermediate Mandarin course.</p>
          </div>
        </div>
      </div>
      )
  }  
}


class ExpTrio extends Component {
  render() {
    return(
      <div className = "row py-3">

        <div className = "col-lg-4">
          <div className = "border border-info rounded">
            <div className = "row mx-3 my-3 justify-content-around">
              <h5>Intern @ FGV Cambridge Nanosystems (Jul-Sep 2017)</h5>  <p><em>(9 weeks)</em></p>
              <p className="text-justify">Carried out research into a graphene-based thermal solution for computing & automotive applications.
Developed equipment and carried out tests to measure the effectiveness of proposed solutions.</p>
            </div>
          </div>
        </div>

        <div className = "col-lg-4">
          <div className = "border border-info rounded">
            <div className = "row mx-3 my-3 justify-content-around">
              <h5>Intern @ Ramboll UK (Sep 2015)</h5>  <p><em>(2 weeks)</em></p>
              <p className="text-justify">Joined the HVAC & Electrical team in the Building Services division.s
              Used updated layout plans of building to check and update schematic plan on AutoCAD.
              Used CIBSE guidelines to decide dimensions of ducts.
              Learned to use industry software to model lighting, cooling and heating in buildings.
              </p>
            </div>
          </div>
        </div>

        <div className = "col-lg-4">
          <div className = "border border-info rounded">
            <div className = "row mx-3 my-3 justify-content-around">
              <h5>Work experience @ Cassini Imaging team (June 2014)</h5> <p><em>(1 week)</em></p>
              <p className="text-justify">Investigated turbulence in Saturn's F Ring, analysing data in Microsoft Excel. Carried out work shadowing and research into orbital mechanics.</p>
              <p className="text-justify"> I won this opportunity as part of the Cassini Scientist for a Day competition, for which I wrote this 
              <a href = "https://sci.esa.int/web/education/-/53727-winners---united-kingdom?fbodylongid=2279"> essay </a>.</p>

            </div>
          </div>
        </div>


      </div>

      )
  }
}

class ExpComedy extends Component {
  render() {
    return(
      <div className = "py-3">
        <div className = "border border-info rounded">
          <div className = "row mx-3 my-4 justify-content-around">
            <div className = "col-lg-4 col-sm-5 d-none d-sm-block">
              <img className = "img-fluid" src="standup_1.jpg" alt=""/>
            </div>
            <div className = "col-lg-4 col-sm-5 col-12">
              <img className = "img-fluid" src="standup_2.jpg" alt=""/>
            </div>
          </div>
          <div className = "row mx-3 my-3">
            <h5> Engineering-themed standup comedy @ Cambridge & London (March & May 2017)</h5>
            <p className="text-justify">I have performed two sets of Engineering-themed comedy in 
            <a href="https://scienceshowoff.wordpress.com/2017/03/16/engineering-showoff-cambridge-tues-21st-march-portland-arms/"> Cambridge </a>
            and <a href="https://www.facebook.com/events/bloomsbury-theatre/engineering-showoff-all-star-gig/415385792167489/"> London </a>, as part of the "Engineering Showoff" public outreach scheme.</p>
          </div>
        </div>
      </div>
      )
  }
}


class Exp extends Component {
  render() {
    return(
      <div className = "row py-5 justify-content-between">
        <h3 className="col-lg-2"> Experience </h3>

        <div className = "col-lg-10">
          <ExpNvidia/>
          <ExpAmazon/>
          <ExpMila/>
          <ExpTHU/>
          <ExpCUER/>
          <ExpHuawei/>         
          <ExpTrio/>
          <ExpComedy/>
        </div>

      </div>
      )
  }
}



export default App;
